<script setup lang="ts">
import { PopoverTrigger as PopoverTriggerInner, type PopoverTriggerProps } from 'reka-ui'

const props = defineProps<PopoverTriggerProps>()
</script>

<template>
  <PopoverTriggerInner
    v-bind="props"
  >
    <slot />
  </PopoverTriggerInner>
</template>
